import React from "react"
import Select from "react-select"
import selectValue from 'helpers/selectValue'

class ReactSelect extends React.Component {

	componentDidMount() {		
		if (this.props.options.length == 1 && this.props.value == "" && !this.props.isMulti && !this.props.disableSoloSelect) {
			this.handleChange({ value: this.props.options[0].value })
		}
	}

    handleChange = value => {
        if(value === null) {
			this.props.onChange(this.props.name, null)
		}
		else if(this.props.isMulti) {
			if(value === null) {
				value = []
			}
			let f = []
			_.forEach(value, r => {
				f.push(r.value)
			})
			if(f.length == 0) {
				// validation fails without this because blank arrays are removed from formik for some reason.
				f = ""
			}
			this.props.onChange(this.props.name, f)
		}
		else {
			this.props.onChange(this.props.name, value.value)
		}
        
	}
	
	selectAll = opt => {
		let f = []
		if(opt) {
			// all
			for(let v of this.props.options) {
				f.push(v)
			}
		}
		this.handleChange(f)
	}

    handleBlur = (v, f) => {
        this.props.onBlur(this.props.name, true)
    }

    render() {
		let options = (this.props.selectAll) ? <div className="selectAll"><span onClick={() => { this.selectAll(true)}}>All</span><span onClick={() => {this.selectAll(false)}}>None</span></div> : ''
        return (
			<>
				{options}
				<Select
					className={this.props.className ? this.props.className : "form__input"}
					classNamePrefix={this.props.classNamePrefix}
					value={selectValue(this.props.options, this.props.value, this.props.allowNull)}
					id={this.props.name}
					options={this.props.options}
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					isMulti={this.props.isMulti}
					key={this.props.keyVal}
					isClearable={this.props.clearable}
					placeholder={this.props.placeholder}
					filterOption={
						this.props.filterOption
							? (opt, val) => {
									// This is for selects where we have the options as <span>s.  It allows styling, so we have to filter based on the `text` param vs the label which will be a react element.
									try {
										let v = val ? val.toLowerCase() : ""
										let option = opt.data.text.toLowerCase()
										if (option.includes(v)) return true
									} catch (e) {
										console.error(`Option type failed in React Select.`)
									}
							  }
							: undefined
					}
				/>
			</>
		)
    }
}

export default ReactSelect
